import React from "react";

export const IconsListDetail = ({ detail, onChangeIcon, selectedIcon }) => {
  const changeIconHandler = () => onChangeIcon(detail);
  return (
    <div
      className={selectedIcon === detail ? "current" : ""}
      onClick={changeIconHandler}
    >
      <img src={detail.url} alt={detail.formattedName} />
    </div>
  );
};
